<template>
  <form>
    <b-field>
      <p>For <b>{{leadDistributionSet.title}}</b>, please select one or more lead owners
        from the list and specify the percentage of leads to be allocated to each owner.</p>
    </b-field>
    <b-table :data="value"
             class="form-table"
             :header-checkable="false"
             :checked-rows.sync="changeCheckedRows"
             checkbox-position="left"
             v-slot="props"
             @check="rowCheckEvent"
             :mobile-cards="false"
             checkable>
      <b-table-column cell-class="cell lead-distribution-owner" field="fullName" width="450">
        <span>{{ props.row.fullName }}</span>
      </b-table-column>
      <b-table-column cell-class="cell" field="percent" width="650">
        <b-field
            v-if="arrayOfCheckedRows.findIndex((elem) => elem.id === props.row.id)
                 >= 0 ? true : false"
            class="percent-input"
            :value="percentToString(props.row.percent)">
          <masked-input class="input percent-masked-input" type="text"
                        :value="percentToString(props.row.percent)"
                        @input="percentChanged($event, props.row.id)"
                        :mask="mask"
                        :pipe="pipe"
                        :guide="false"
                        placeholder="0%">
          </masked-input>
        </b-field>
      </b-table-column>
    </b-table>
  </form>
</template>

<script>
import { VueMaskDirective } from 'v-mask';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import MaskedInput from 'vue-text-mask';

export default {
  name: 'LeadDistributionOwner',
  directives: { mask: VueMaskDirective },
  components: {
    MaskedInput,
  },
  props: {
    value: {},
    leadDistributionSet: {},
    checkedRows: {},
  },
  computed: {
    changeCheckedRows: {
      get() {
        return this.arrayOfCheckedRows;
      },
      set(val) {
        this.arrayOfCheckedRows = val;
        this.$emit('checking-row', val);
        return val;
      },
    },
  },
  data() {
    return {
      arrayOfCheckedRows: this.checkedRows,
      mask: createNumberMask({
        prefix: '',
        suffix: '%',
        allowDecimal: false,
        integerLimit: 3,
        includeThousandsSeparator: false,
        allowNegative: false,
        placeholder: '0%',
      }),
      pipe: (confirmedValue, config) => {
        const valNumber = Number(confirmedValue.replace('%', ''));
        if (valNumber >= 0 && valNumber <= 100) {
          if (confirmedValue.length && confirmedValue.search(/%/) < 0) return `${confirmedValue}%`;
          return confirmedValue;
        }
        return config.previousConformedValue;
      },
    };
  },
  mounted() {
    const htmlTableRows = document.querySelectorAll('td.checkbox-cell label.b-checkbox');
    htmlTableRows.forEach((item) => {
      item.addEventListener('keydown', (event) => {
        if (event.code === 'Space') {
          event.preventDefault();
          const eventClick = new Event('click', { bubbles: true, cancelable: true });
          item.dispatchEvent(eventClick);
        }
      });
    });
  },
  methods: {
    percentChanged(val, id) {
      const idx = this.value.findIndex((elem) => elem.id === id);
      if (idx > -1) {
        this.value[idx].percent = Number(val.replace('%', ''));
      }
      this.$emit('percent-changed');
    },
    percentToString(percent) {
      return `${percent.toString()}%`;
    },
    rowCheckEvent(arr, obj) {
      const idx = this.value.findIndex((elem) => elem.id === obj.id);
      if (idx > -1) {
        this.value[idx].percent = 0;
      }
    },
    /**
     * Until 40 - control keys {arrows, backspace, delete, home ...}
     * Between 48-57 - numbers
     * Between 96-105 - numbers numlock
     * 46 - DEL key
     * 67,86,88,90 - Ctrl+{c,z,x,v}
     */
    inputFiltering(event) {
      const isInvalid = (keyCode) => keyCode === 32 || ((((keyCode < 48 || keyCode > 57)
              && (keyCode < 96 || keyCode > 105)))
          && keyCode !== 46) || event.shiftKey === true;

      const isCvCc = () => [67, 86, 88, 90].includes(event.keyCode)
          && event.ctrlKey === true;

      const isControl = () => event.keyCode !== 32 && (event.keyCode < 40 || event.keyCode === 46);

      const isSelection = () => event.target.selectionStart - event.target.selectionEnd !== 0;

      if (isControl() || isCvCc()) {
        // eslint-disable-next-line no-restricted-globals
        return;
      }

      if (isSelection() && !isInvalid(event.keyCode)) {
        return;
      }

      if (isInvalid(event.keyCode) || event.target.value.length > 3) {
        event.preventDefault();
      }
    },
    pasteFiltering(event) {
      const paste = event.clipboardData || window.clipboardData;
      const data = paste.getData('text');
      const { value } = event.target;

      if (!data.match('^\\d{0,3}$')) {
        event.preventDefault();
        this.$buefy.toast.open({
          message: 'Only numbers are allowed, max size 3',
          type: 'is-warning',
        });
      }

      if ((value.length - (event.target.selectionEnd - event.target.selectionStart)
          + data.length) > 3) {
        event.preventDefault();
        this.$buefy.toast.open({
          message: 'Only numbers are allowed, max size 3',
          type: 'is-warning',
        });
      }
    },
  },
};
</script>

<style scoped lang="stylus">
.form-table
  margin-bottom 20px
.b-table
  min-height 150px
.b-table >>> td.checkbox-cell
  border-bottom none
.b-table >>> tbody tr:last-child td
  border-bottom 1px solid #D1DBE0!important
.b-table >>> thead tr th
  border none
tbody tr td
  border none
.b-table >>> tr td
  border-top 1px solid #D1DBE0!important
.b-table td:nth-child(even)
  background-color transparent
.percent-masked-input
  text-align right
.b-table >>> tbody tr td.checkbox-cell label.b-checkbox.checkbox:hover span.check
  border-color #47c68d
.b-table >>> tbody tr.is-checked
  td.checkbox-cell label.b-checkbox.checkbox span.check
    border-color #47c68d
    background #47c68d url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath style='fill:%23fff' d='M 0.04038059,0.6267767 0.14644661,0.52071068 0.42928932,0.80355339 0.3232233,0.90961941 z M 0.21715729,0.80355339 0.85355339,0.16715729 0.95961941,0.2732233 0.3232233,0.90961941 z'%3E%3C/path%3E%3C/svg%3E") no-repeat center center
.lead-distribution-owner
  font-size 16px
  white-space normal
.percent-input
  min-width 65px
</style>
